import React from 'react';
import Link from 'router/Link';
import PropTypes from 'prop-types';
import {SLICE_PROP_TYPES} from '../cms-prop-types';
// Creating in advance of using CSS modudles with dex
// import css from './InternalLinkList.module.scss';

const InternalLinkList = ({slice}) => (
    <div className="InternalLinkList">
        <h3>{slice.primary.list_title}</h3>
        {slice.items.map((link, i) => (
            <Link to={link.link_path} className="InternalLinkList-link" key={i}>
                {link.link_text}
            </Link>
        ))}
    </div>
);

/* eslint-disable camelcase */
InternalLinkList.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            list_title: PropTypes.string.isRequired,
        }).isRequired,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                link_path: PropTypes.string.isRequired,
                link_text: PropTypes.string.isRequired,
            })
        ).isRequired,
    }).isRequired,
};

export default InternalLinkList;
